/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

export const viewDictionary = {};

viewDictionary['__local__|__local__|modules|back-to-top|back-to-top'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-back-to-top' */
                'partner/modules/back-to-top/back-to-top.view.tsx'),
            cn: '__local__-__local__-back-to-top'
            };
viewDictionary['__local__|__local__|modules|category-tile|category-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-category-tile' */
                'partner/modules/category-tile/category-tile.view.tsx'),
            cn: '__local__-__local__-category-tile'
            };
viewDictionary['__local__|__local__|modules|checkout-invoice|checkout-invoice'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-invoice' */
                'partner/modules/checkout-invoice/checkout-invoice.view.tsx'),
            cn: '__local__-__local__-checkout-invoice'
            };
viewDictionary['__local__|__local__|modules|checkout-payment-instrument-v002|checkout-payment-instrument-v002'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-payment-instrument-v002' */
                'partner/modules/checkout-payment-instrument-v002/checkout-payment-instrument-v002.view.tsx'),
            cn: '__local__-__local__-checkout-payment-instrument-v002'
            };
viewDictionary['__local__|__local__|modules|commision-junction|commision-junction'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-commision-junction' */
                'partner/modules/commision-junction/commision-junction.view.tsx'),
            cn: '__local__-__local__-commision-junction'
            };
viewDictionary['__local__|__local__|modules|country-selector|country-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-country-selector' */
                'partner/modules/country-selector/country-selector.view.tsx'),
            cn: '__local__-__local__-country-selector'
            };
viewDictionary['__local__|__local__|modules|custom-checkout-apple-pay|custom-checkout-apple-pay'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-checkout-apple-pay' */
                'partner/modules/custom-checkout-apple-pay/custom-checkout-apple-pay.view.tsx'),
            cn: '__local__-__local__-custom-checkout-apple-pay'
            };
viewDictionary['__local__|__local__|modules|custom-checkout-google-pay|custom-checkout-google-pay'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-checkout-google-pay' */
                'partner/modules/custom-checkout-google-pay/custom-checkout-google-pay.view.tsx'),
            cn: '__local__-__local__-custom-checkout-google-pay'
            };
viewDictionary['__local__|__local__|modules|custom-checkout-shipping-address|custom-checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-checkout-shipping-address' */
                'partner/modules/custom-checkout-shipping-address/custom-checkout-shipping-address.view.tsx'),
            cn: '__local__-__local__-custom-checkout-shipping-address'
            };
viewDictionary['__local__|__local__|modules|custom-contentcode-block|custom-contentcode-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-contentcode-block' */
                'partner/modules/custom-contentcode-block/custom-contentcode-block.view.tsx'),
            cn: '__local__-__local__-custom-contentcode-block'
            };
viewDictionary['__local__|__local__|modules|custom-image-banner|custom-image-banner'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-custom-image-banner' */
                'partner/modules/custom-image-banner/custom-image-banner.view.tsx'),
            cn: '__local__-__local__-custom-image-banner'
            };
viewDictionary['__local__|__local__|modules|email-verification|email-verification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-email-verification' */
                'partner/modules/email-verification/email-verification.view.tsx'),
            cn: '__local__-__local__-email-verification'
            };
viewDictionary['__local__|__local__|modules|filtered-delivery-options|filtered-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-filtered-delivery-options' */
                'partner/modules/filtered-delivery-options/filtered-delivery-options.view.tsx'),
            cn: '__local__-__local__-filtered-delivery-options'
            };
viewDictionary['__local__|__local__|modules|find-store-worldwide|find-store-worldwide'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-find-store-worldwide' */
                'partner/modules/find-store-worldwide/find-store-worldwide.view.tsx'),
            cn: '__local__-__local__-find-store-worldwide'
            };
viewDictionary['__local__|__local__|modules|fm-account-profile|fm-account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-fm-account-profile' */
                'partner/modules/fm-account-profile/fm-account-profile.view.tsx'),
            cn: '__local__-__local__-fm-account-profile'
            };
viewDictionary['__local__|__local__|modules|footer-navigation-menu|footer-navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-footer-navigation-menu' */
                'partner/modules/footer-navigation-menu/footer-navigation-menu.view.tsx'),
            cn: '__local__-__local__-footer-navigation-menu'
            };
viewDictionary['__local__|__local__|modules|generic-popup|generic-popup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-generic-popup' */
                'partner/modules/generic-popup/generic-popup.view.tsx'),
            cn: '__local__-__local__-generic-popup'
            };
viewDictionary['__local__|__local__|modules|gift-card-personalization|gift-card-personalization'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gift-card-personalization' */
                'partner/modules/gift-card-personalization/gift-card-personalization.view.tsx'),
            cn: '__local__-__local__-gift-card-personalization'
            };
viewDictionary['__local__|__local__|modules|gift-with-purchase|gift-with-purchase'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-gift-with-purchase' */
                'partner/modules/gift-with-purchase/gift-with-purchase.view.tsx'),
            cn: '__local__-__local__-gift-with-purchase'
            };
viewDictionary['__local__|__local__|modules|hero-banner-slide|hero-banner-slide'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hero-banner-slide' */
                'partner/modules/hero-banner-slide/hero-banner-slide.view.tsx'),
            cn: '__local__-__local__-hero-banner-slide'
            };
viewDictionary['__local__|__local__|modules|hero-banner|hero-banner'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hero-banner' */
                'partner/modules/hero-banner/hero-banner.view.tsx'),
            cn: '__local__-__local__-hero-banner'
            };
viewDictionary['__local__|__local__|modules|loyalty-balance-check|loyalty-balance-check'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-balance-check' */
                'partner/modules/loyalty-balance-check/loyalty-balance-check.view.tsx'),
            cn: '__local__-__local__-loyalty-balance-check'
            };
viewDictionary['__local__|__local__|modules|loyalty-store-sign-up|loyalty-store-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-store-sign-up' */
                'partner/modules/loyalty-store-sign-up/loyalty-store-sign-up.view.tsx'),
            cn: '__local__-__local__-loyalty-store-sign-up'
            };
viewDictionary['__local__|__local__|modules|map-custom|map-custom'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-map-custom' */
                'partner/modules/map-custom/map-custom.view.tsx'),
            cn: '__local__-__local__-map-custom'
            };
viewDictionary['__local__|__local__|modules|new-checkout-delivery-options|new-checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-new-checkout-delivery-options' */
                'partner/modules/new-checkout-delivery-options/new-checkout-delivery-options.view.tsx'),
            cn: '__local__-__local__-new-checkout-delivery-options'
            };
viewDictionary['__local__|__local__|modules|new-checkout-shipping-address|new-checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-new-checkout-shipping-address' */
                'partner/modules/new-checkout-shipping-address/new-checkout-shipping-address.view.tsx'),
            cn: '__local__-__local__-new-checkout-shipping-address'
            };
viewDictionary['__local__|__local__|modules|new-sign-up|new-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-new-sign-up' */
                'partner/modules/new-sign-up/new-sign-up.view.tsx'),
            cn: '__local__-__local__-new-sign-up'
            };
viewDictionary['__local__|__local__|modules|newsletter-block|newsletter-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-newsletter-block' */
                'partner/modules/newsletter-block/newsletter-block.view.tsx'),
            cn: '__local__-__local__-newsletter-block'
            };
viewDictionary['__local__|__local__|modules|plp-subheader|plp-subheader'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-plp-subheader' */
                'partner/modules/plp-subheader/plp-subheader.view.tsx'),
            cn: '__local__-__local__-plp-subheader'
            };
viewDictionary['__local__|__local__|modules|pva-chat-connector|pva-chat-connector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-pva-chat-connector' */
                'partner/modules/pva-chat-connector/pva-chat-connector.view.tsx'),
            cn: '__local__-__local__-pva-chat-connector'
            };
viewDictionary['__local__|__local__|modules|region-selector|region-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-region-selector' */
                'partner/modules/region-selector/region-selector.view.tsx'),
            cn: '__local__-__local__-region-selector'
            };
viewDictionary['__local__|__local__|modules|region-tile-selector|region-tile-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-region-tile-selector' */
                'partner/modules/region-tile-selector/region-tile-selector.view.tsx'),
            cn: '__local__-__local__-region-tile-selector'
            };
viewDictionary['__local__|__local__|modules|timeline|timeline'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-timeline' */
                'partner/modules/timeline/timeline.view.tsx'),
            cn: '__local__-__local__-timeline'
            };
viewDictionary['__local__|__local__|modules|unsubscribe-newsletter|unsubscribe-newsletter'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-unsubscribe-newsletter' */
                'partner/modules/unsubscribe-newsletter/unsubscribe-newsletter.view.tsx'),
            cn: '__local__-__local__-unsubscribe-newsletter'
            };
viewDictionary['__local__|__local__|modules|webform|webform'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-webform' */
                'partner/modules/webform/webform.view.tsx'),
            cn: '__local__-__local__-webform'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|account-generic-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-generic-tile' */
                'partner/themes/venchi-v2-1/views/account-generic-tile.view.tsx'),
            cn: '__local__-__local__-account-generic-tile'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|account-loyalty-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-loyalty-tile' */
                'partner/themes/venchi-v2-1/views/account-loyalty-tile.view.tsx'),
            cn: '__local__-__local__-account-loyalty-tile'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|account-loyalty'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-loyalty' */
                'partner/themes/venchi-v2-1/views/account-loyalty.view.tsx'),
            cn: '__local__-__local__-account-loyalty'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|account-management-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-management-address' */
                'partner/themes/venchi-v2-1/views/account-management-address.view.tsx'),
            cn: '__local__-__local__-account-management-address'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-profile' */
                'partner/themes/venchi-v2-1/views/account-profile.view.tsx'),
            cn: '__local__-__local__-account-profile'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|breadcrumb'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-breadcrumb' */
                'partner/themes/venchi-v2-1/views/breadcrumb.view.tsx'),
            cn: '__local__-__local__-breadcrumb'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-buybox' */
                'partner/themes/venchi-v2-1/views/buybox.view.tsx'),
            cn: '__local__-__local__-buybox'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-icon' */
                'partner/themes/venchi-v2-1/views/cart-icon.view.tsx'),
            cn: '__local__-__local__-cart-icon'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart' */
                'partner/themes/venchi-v2-1/views/cart.view.tsx'),
            cn: '__local__-__local__-cart'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-delivery-options' */
                'partner/themes/venchi-v2-1/views/checkout-delivery-options.view.tsx'),
            cn: '__local__-__local__-checkout-delivery-options'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|checkout'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout' */
                'partner/themes/venchi-v2-1/views/checkout.view.tsx'),
            cn: '__local__-__local__-checkout'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-block' */
                'partner/themes/venchi-v2-1/views/content-block.view.tsx'),
            cn: '__local__-__local__-content-block'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|country-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-country-selector' */
                'partner/themes/venchi-v2-1/views/country-selector.view.tsx'),
            cn: '__local__-__local__-country-selector'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-header' */
                'partner/themes/venchi-v2-1/views/header.view.tsx'),
            cn: '__local__-__local__-header'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|iframe'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-iframe' */
                'partner/themes/venchi-v2-1/views/iframe.view.tsx'),
            cn: '__local__-__local__-iframe'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|loyalty-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-sign-up' */
                'partner/themes/venchi-v2-1/views/loyalty-sign-up.view.tsx'),
            cn: '__local__-__local__-loyalty-sign-up'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|loyalty-terms'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-terms' */
                'partner/themes/venchi-v2-1/views/loyalty-terms.view.tsx'),
            cn: '__local__-__local__-loyalty-terms'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-media-gallery' */
                'partner/themes/venchi-v2-1/views/media-gallery.view.tsx'),
            cn: '__local__-__local__-media-gallery'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-navigation-menu' */
                'partner/themes/venchi-v2-1/views/navigation-menu.view.tsx'),
            cn: '__local__-__local__-navigation-menu'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-confirmation' */
                'partner/themes/venchi-v2-1/views/order-confirmation.view.tsx'),
            cn: '__local__-__local__-order-confirmation'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details' */
                'partner/themes/venchi-v2-1/views/order-details.view.tsx'),
            cn: '__local__-__local__-order-details'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history' */
                'partner/themes/venchi-v2-1/views/order-history.view.tsx'),
            cn: '__local__-__local__-order-history'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template-list' */
                'partner/themes/venchi-v2-1/views/order-template-list.view.tsx'),
            cn: '__local__-__local__-order-template-list'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|product-collection'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-collection' */
                'partner/themes/venchi-v2-1/views/product-collection.view.tsx'),
            cn: '__local__-__local__-product-collection'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|product-specification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-specification' */
                'partner/themes/venchi-v2-1/views/product-specification.view.tsx'),
            cn: '__local__-__local__-product-specification'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|promo-banner'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-promo-banner' */
                'partner/themes/venchi-v2-1/views/promo-banner.view.tsx'),
            cn: '__local__-__local__-promo-banner'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ratings-histogram' */
                'partner/themes/venchi-v2-1/views/ratings-histogram.view.tsx'),
            cn: '__local__-__local__-ratings-histogram'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reviews-list' */
                'partner/themes/venchi-v2-1/views/reviews-list.view.tsx'),
            cn: '__local__-__local__-reviews-list'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search-result-container' */
                'partner/themes/venchi-v2-1/views/search-result-container.view.tsx'),
            cn: '__local__-__local__-search-result-container'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search' */
                'partner/themes/venchi-v2-1/views/search.view.tsx'),
            cn: '__local__-__local__-search'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-in' */
                'partner/themes/venchi-v2-1/views/sign-in.view.tsx'),
            cn: '__local__-__local__-sign-in'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-up' */
                'partner/themes/venchi-v2-1/views/sign-up.view.tsx'),
            cn: '__local__-__local__-sign-up'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|store-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-store-selector' */
                'partner/themes/venchi-v2-1/views/store-selector.view.tsx'),
            cn: '__local__-__local__-store-selector'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|video-player'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-video-player' */
                'partner/themes/venchi-v2-1/views/video-player.view.tsx'),
            cn: '__local__-__local__-video-player'
            };
viewDictionary['__local__|__local__|themes|venchi-v2-1|views|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-write-review' */
                'partner/themes/venchi-v2-1/views/write-review.view.tsx'),
            cn: '__local__-__local__-write-review'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|account-generic-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-generic-tile' */
                'partner/themes/venchi-v2/views/account-generic-tile.view.tsx'),
            cn: '__local__-__local__-account-generic-tile'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|account-loyalty-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-loyalty-tile' */
                'partner/themes/venchi-v2/views/account-loyalty-tile.view.tsx'),
            cn: '__local__-__local__-account-loyalty-tile'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|account-loyalty'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-loyalty' */
                'partner/themes/venchi-v2/views/account-loyalty.view.tsx'),
            cn: '__local__-__local__-account-loyalty'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|account-management-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-management-address' */
                'partner/themes/venchi-v2/views/account-management-address.view.tsx'),
            cn: '__local__-__local__-account-management-address'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-account-profile' */
                'partner/themes/venchi-v2/views/account-profile.view.tsx'),
            cn: '__local__-__local__-account-profile'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|breadcrumb'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-breadcrumb' */
                'partner/themes/venchi-v2/views/breadcrumb.view.tsx'),
            cn: '__local__-__local__-breadcrumb'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-buybox' */
                'partner/themes/venchi-v2/views/buybox.view.tsx'),
            cn: '__local__-__local__-buybox'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart-icon' */
                'partner/themes/venchi-v2/views/cart-icon.view.tsx'),
            cn: '__local__-__local__-cart-icon'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-cart' */
                'partner/themes/venchi-v2/views/cart.view.tsx'),
            cn: '__local__-__local__-cart'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout-delivery-options' */
                'partner/themes/venchi-v2/views/checkout-delivery-options.view.tsx'),
            cn: '__local__-__local__-checkout-delivery-options'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|checkout'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-checkout' */
                'partner/themes/venchi-v2/views/checkout.view.tsx'),
            cn: '__local__-__local__-checkout'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-content-block' */
                'partner/themes/venchi-v2/views/content-block.view.tsx'),
            cn: '__local__-__local__-content-block'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-header' */
                'partner/themes/venchi-v2/views/header.view.tsx'),
            cn: '__local__-__local__-header'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|iframe'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-iframe' */
                'partner/themes/venchi-v2/views/iframe.view.tsx'),
            cn: '__local__-__local__-iframe'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|loyalty-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-sign-up' */
                'partner/themes/venchi-v2/views/loyalty-sign-up.view.tsx'),
            cn: '__local__-__local__-loyalty-sign-up'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|loyalty-terms'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-loyalty-terms' */
                'partner/themes/venchi-v2/views/loyalty-terms.view.tsx'),
            cn: '__local__-__local__-loyalty-terms'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-media-gallery' */
                'partner/themes/venchi-v2/views/media-gallery.view.tsx'),
            cn: '__local__-__local__-media-gallery'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-navigation-menu' */
                'partner/themes/venchi-v2/views/navigation-menu.view.tsx'),
            cn: '__local__-__local__-navigation-menu'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-confirmation' */
                'partner/themes/venchi-v2/views/order-confirmation.view.tsx'),
            cn: '__local__-__local__-order-confirmation'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-details' */
                'partner/themes/venchi-v2/views/order-details.view.tsx'),
            cn: '__local__-__local__-order-details'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-history' */
                'partner/themes/venchi-v2/views/order-history.view.tsx'),
            cn: '__local__-__local__-order-history'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-order-template-list' */
                'partner/themes/venchi-v2/views/order-template-list.view.tsx'),
            cn: '__local__-__local__-order-template-list'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|product-collection'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-collection' */
                'partner/themes/venchi-v2/views/product-collection.view.tsx'),
            cn: '__local__-__local__-product-collection'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|product-specification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-product-specification' */
                'partner/themes/venchi-v2/views/product-specification.view.tsx'),
            cn: '__local__-__local__-product-specification'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-ratings-histogram' */
                'partner/themes/venchi-v2/views/ratings-histogram.view.tsx'),
            cn: '__local__-__local__-ratings-histogram'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-reviews-list' */
                'partner/themes/venchi-v2/views/reviews-list.view.tsx'),
            cn: '__local__-__local__-reviews-list'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search-result-container' */
                'partner/themes/venchi-v2/views/search-result-container.view.tsx'),
            cn: '__local__-__local__-search-result-container'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-search' */
                'partner/themes/venchi-v2/views/search.view.tsx'),
            cn: '__local__-__local__-search'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-in' */
                'partner/themes/venchi-v2/views/sign-in.view.tsx'),
            cn: '__local__-__local__-sign-in'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-sign-up' */
                'partner/themes/venchi-v2/views/sign-up.view.tsx'),
            cn: '__local__-__local__-sign-up'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|store-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-store-selector' */
                'partner/themes/venchi-v2/views/store-selector.view.tsx'),
            cn: '__local__-__local__-store-selector'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|video-player'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-video-player' */
                'partner/themes/venchi-v2/views/video-player.view.tsx'),
            cn: '__local__-__local__-video-player'
            };
viewDictionary['__local__|__local__|themes|venchi-v2|views|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-write-review' */
                'partner/themes/venchi-v2/views/write-review.view.tsx'),
            cn: '__local__-__local__-write-review'
            };
viewDictionary['@msdyn365-commerce-modules|accordion|modules|accordion-item|accordion-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-accordion-accordion-item' */
                '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion-item/accordion-item.view.js'),
            cn: '@msdyn365-commerce-modules-accordion-accordion-item'
            };
viewDictionary['@msdyn365-commerce-modules|accordion|modules|accordion|accordion'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-accordion-accordion' */
                '@msdyn365-commerce-modules/accordion/dist/lib/modules/accordion/accordion.view.js'),
            cn: '@msdyn365-commerce-modules-accordion-accordion'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|aad-generic|aad-generic'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-aad-generic' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/aad-generic/aad-generic.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-aad-generic'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-address-tile|account-address-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-address-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-address-tile/account-address-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-address-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-customer-balance-tile|account-customer-balance-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-customer-balance-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance-tile/account-customer-balance-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-customer-balance-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-customer-balance|account-customer-balance'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-customer-balance' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-customer-balance/account-customer-balance.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-customer-balance'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-generic-tile|account-generic-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-generic-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-generic-tile/account-generic-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-generic-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-invoice-tile|account-invoice-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-invoice-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-invoice-tile/account-invoice-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-invoice-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-loyalty-tile|account-loyalty-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-loyalty-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty-tile/account-loyalty-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-loyalty-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-loyalty|account-loyalty'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-loyalty' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-loyalty/account-loyalty.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-loyalty'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-order-templates-tile|account-order-templates-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-order-templates-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-order-templates-tile/account-order-templates-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-order-templates-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-profile-edit|account-profile-edit'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-profile-edit' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile-edit/account-profile-edit.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-profile-edit'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-profile|account-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-profile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-profile/account-profile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-profile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-welcome-tile|account-welcome-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-welcome-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-welcome-tile/account-welcome-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-welcome-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|account-wishlist-tile|account-wishlist-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-account-wishlist-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/account-wishlist-tile/account-wishlist-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-account-wishlist-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|b2b-requests-status|b2b-requests-status'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-b2b-requests-status' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-status/b2b-requests-status.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-b2b-requests-status'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|b2b-requests-tile|b2b-requests-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-b2b-requests-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/b2b-requests-tile/b2b-requests-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-b2b-requests-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|loyalty-sign-up|loyalty-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-loyalty-sign-up' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-sign-up/loyalty-sign-up.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-loyalty-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|loyalty-terms|loyalty-terms'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-loyalty-terms' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/loyalty-terms/loyalty-terms.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-loyalty-terms'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|organization-users-tile|organization-users-tile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-organization-users-tile' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/organization-users-tile/organization-users-tile.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-organization-users-tile'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset-verification|password-reset-verification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-password-reset-verification' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset-verification/password-reset-verification.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-password-reset-verification'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|password-reset|password-reset'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-password-reset' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/password-reset/password-reset.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-password-reset'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-in|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-sign-in' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-in/sign-in.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-sign-in'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-up|sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-account-management-sign-up' */
                '@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up.view.js'),
            cn: '@msdyn365-commerce-modules-account-management-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|active-image|modules|active-image|active-image'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-active-image-active-image' */
                '@msdyn365-commerce-modules/active-image/dist/lib/modules/active-image/active-image.view.js'),
            cn: '@msdyn365-commerce-modules-active-image-active-image'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|account-management-address|account-management-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-account-management-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/account-management-address/account-management-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-account-management-address'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|business-account-address|business-account-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-business-account-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/business-account-address/business-account-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-business-account-address'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|checkout-billing-address|checkout-billing-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-checkout-billing-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-billing-address/checkout-billing-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-checkout-billing-address'
            };
viewDictionary['@msdyn365-commerce-modules|address|modules|checkout-shipping-address|checkout-shipping-address'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-address-checkout-shipping-address' */
                '@msdyn365-commerce-modules/address/dist/lib/modules/checkout-shipping-address/checkout-shipping-address.view.js'),
            cn: '@msdyn365-commerce-modules-address-checkout-shipping-address'
            };
viewDictionary['@msdyn365-commerce-modules|azure-maps|modules|azure-maps|azure-maps'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-azure-maps-azure-maps' */
                '@msdyn365-commerce-modules/azure-maps/dist/lib/modules/azure-maps/azure-maps.view.js'),
            cn: '@msdyn365-commerce-modules-azure-maps-azure-maps'
            };
viewDictionary['@msdyn365-commerce-modules|breadcrumb|modules|breadcrumb|breadcrumb'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-breadcrumb-breadcrumb' */
                '@msdyn365-commerce-modules/breadcrumb/dist/lib/modules/breadcrumb/breadcrumb.view.js'),
            cn: '@msdyn365-commerce-modules-breadcrumb-breadcrumb'
            };
viewDictionary['@msdyn365-commerce-modules|bulk-purchase|modules|bulk-purchase|bulk-purchase'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-bulk-purchase-bulk-purchase' */
                '@msdyn365-commerce-modules/bulk-purchase/dist/lib/modules/bulk-purchase/bulk-purchase.view.js'),
            cn: '@msdyn365-commerce-modules-bulk-purchase-bulk-purchase'
            };
viewDictionary['@msdyn365-commerce-modules|business-account-management|modules|business-sign-up|business-sign-up'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-account-management-business-sign-up' */
                '@msdyn365-commerce-modules/business-account-management/dist/lib/modules/business-sign-up/business-sign-up.view.js'),
            cn: '@msdyn365-commerce-modules-business-account-management-business-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|business-organization-list|modules|business-organization-list|business-organization-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-organization-list-business-organization-list' */
                '@msdyn365-commerce-modules/business-organization-list/dist/lib/modules/business-organization-list/business-organization-list.view.js'),
            cn: '@msdyn365-commerce-modules-business-organization-list-business-organization-list'
            };
viewDictionary['@msdyn365-commerce-modules|business-partner-promotion|modules|business-partner-promotion|business-partner-promotion'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-partner-promotion-business-partner-promotion' */
                '@msdyn365-commerce-modules/business-partner-promotion/dist/lib/modules/business-partner-promotion/business-partner-promotion.view.js'),
            cn: '@msdyn365-commerce-modules-business-partner-promotion-business-partner-promotion'
            };
viewDictionary['@msdyn365-commerce-modules|business-partners|modules|business-partners|business-partners'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-business-partners-business-partners' */
                '@msdyn365-commerce-modules/business-partners/dist/lib/modules/business-partners/business-partners.view.js'),
            cn: '@msdyn365-commerce-modules-business-partners-business-partners'
            };
viewDictionary['@msdyn365-commerce-modules|buybox|modules|buybox|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-buybox-buybox' */
                '@msdyn365-commerce-modules/buybox/dist/lib/modules/buybox/buybox.view.js'),
            cn: '@msdyn365-commerce-modules-buybox-buybox'
            };
viewDictionary['@msdyn365-commerce-modules|buybox|modules|quickview|quickview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-buybox-quickview' */
                '@msdyn365-commerce-modules/buybox/dist/lib/modules/quickview/quickview.view.js'),
            cn: '@msdyn365-commerce-modules-buybox-quickview'
            };
viewDictionary['@msdyn365-commerce-modules|carousel|modules|carousel|carousel'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-carousel-carousel' */
                '@msdyn365-commerce-modules/carousel/dist/lib/modules/carousel/carousel.view.js'),
            cn: '@msdyn365-commerce-modules-carousel-carousel'
            };
viewDictionary['@msdyn365-commerce-modules|cart|modules|cart-icon|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-cart-cart-icon' */
                '@msdyn365-commerce-modules/cart/dist/lib/modules/cart-icon/cart-icon.view.js'),
            cn: '@msdyn365-commerce-modules-cart-cart-icon'
            };
viewDictionary['@msdyn365-commerce-modules|cart|modules|cart|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-cart-cart' */
                '@msdyn365-commerce-modules/cart/dist/lib/modules/cart/cart.view.js'),
            cn: '@msdyn365-commerce-modules-cart-cart'
            };
viewDictionary['@msdyn365-commerce-modules|catalog-picker|modules|catalog-picker|catalog-picker'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-catalog-picker-catalog-picker' */
                '@msdyn365-commerce-modules/catalog-picker/dist/lib/modules/catalog-picker/catalog-picker.view.js'),
            cn: '@msdyn365-commerce-modules-catalog-picker-catalog-picker'
            };
viewDictionary['@msdyn365-commerce-modules|chat|modules|msdyn365-cs-chat-connector|msdyn365-cs-chat-connector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-chat-msdyn365-cs-chat-connector' */
                '@msdyn365-commerce-modules/chat/dist/lib/modules/msdyn365-cs-chat-connector/msdyn365-cs-chat-connector.view.js'),
            cn: '@msdyn365-commerce-modules-chat-msdyn365-cs-chat-connector'
            };
viewDictionary['@msdyn365-commerce-modules|chat|modules|msdyn365-pva-chat-connector|msdyn365-pva-chat-connector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-chat-msdyn365-pva-chat-connector' */
                '@msdyn365-commerce-modules/chat/dist/lib/modules/msdyn365-pva-chat-connector/msdyn365-pva-chat-connector.view.js'),
            cn: '@msdyn365-commerce-modules-chat-msdyn365-pva-chat-connector'
            };
viewDictionary['@msdyn365-commerce-modules|check-in-for-pickup|modules|check-in-for-pickup|check-in-for-pickup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-check-in-for-pickup-check-in-for-pickup' */
                '@msdyn365-commerce-modules/check-in-for-pickup/dist/lib/modules/check-in-for-pickup/check-in-for-pickup.view.js'),
            cn: '@msdyn365-commerce-modules-check-in-for-pickup-check-in-for-pickup'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-apple-pay|checkout-apple-pay'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-apple-pay' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-apple-pay/checkout-apple-pay.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-apple-pay'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-customer-account-payment|checkout-customer-account-payment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-customer-account-payment' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-customer-account-payment/checkout-customer-account-payment.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-customer-account-payment'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-delivery-options|checkout-delivery-options'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-delivery-options' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-delivery-options/checkout-delivery-options.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-delivery-options'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-express-payment-container|checkout-express-payment-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-express-payment-container' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-express-payment-container/checkout-express-payment-container.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-express-payment-container'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-express|checkout-express'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-express' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-express/checkout-express.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-express'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-gift-card|checkout-gift-card'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-gift-card' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-gift-card/checkout-gift-card.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-gift-card'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-google-pay|checkout-google-pay'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-google-pay' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-google-pay/checkout-google-pay.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-google-pay'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-guest-profile|checkout-guest-profile'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-guest-profile' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-guest-profile/checkout-guest-profile.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-guest-profile'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-loyalty|checkout-loyalty'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-loyalty' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-loyalty/checkout-loyalty.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-loyalty'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-payment-instrument|checkout-payment-instrument'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-payment-instrument' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-payment-instrument/checkout-payment-instrument.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-payment-instrument'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-pickup|checkout-pickup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-pickup' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-pickup/checkout-pickup.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-pickup'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-section-container|checkout-section-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-section-container' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-section-container/checkout-section-container.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-section-container'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout-terms-and-conditions|checkout-terms-and-conditions'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout-terms-and-conditions' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout-terms-and-conditions/checkout-terms-and-conditions.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout-terms-and-conditions'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|checkout|checkout'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-checkout' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/checkout/checkout.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-checkout'
            };
viewDictionary['@msdyn365-commerce-modules|checkout|modules|gift-card-balance-check|gift-card-balance-check'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-checkout-gift-card-balance-check' */
                '@msdyn365-commerce-modules/checkout/dist/lib/modules/gift-card-balance-check/gift-card-balance-check.view.js'),
            cn: '@msdyn365-commerce-modules-checkout-gift-card-balance-check'
            };
viewDictionary['@msdyn365-commerce-modules|content-block|modules|content-block|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-content-block-content-block' */
                '@msdyn365-commerce-modules/content-block/dist/lib/modules/content-block/content-block.view.js'),
            cn: '@msdyn365-commerce-modules-content-block-content-block'
            };
viewDictionary['@msdyn365-commerce-modules|cookie-compliance|modules|cookie-compliance|cookie-compliance'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance' */
                '@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance.view.js'),
            cn: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance'
            };
viewDictionary['@msdyn365-commerce-modules|country-picker|modules|country-picker|country-picker'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-country-picker-country-picker' */
                '@msdyn365-commerce-modules/country-picker/dist/lib/modules/country-picker/country-picker.view.js'),
            cn: '@msdyn365-commerce-modules-country-picker-country-picker'
            };
viewDictionary['@msdyn365-commerce-modules|distributor-selector|modules|distributor-selector|distributor-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-distributor-selector-distributor-selector' */
                '@msdyn365-commerce-modules/distributor-selector/dist/lib/modules/distributor-selector/distributor-selector.view.js'),
            cn: '@msdyn365-commerce-modules-distributor-selector-distributor-selector'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-buybox' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/buybox.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-buybox'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-cart' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/cart.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-cart'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-header' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/header.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-header'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-navigation-menu' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/navigation-menu.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-navigation-menu'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-order-details' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/order-details.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-order-details'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-order-history' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/order-history.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-order-history'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-ratings-histogram' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/ratings-histogram.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-ratings-histogram'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-reviews-list' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/reviews-list.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-reviews-list'
            };
viewDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-fabrikam-design-kit-search-result-container' */
                '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/search-result-container.view.js'),
            cn: '@msdyn365-commerce-modules-fabrikam-design-kit-search-result-container'
            };
viewDictionary['@msdyn365-commerce-modules|footer|modules|footer-category|footer-category'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-footer-footer-category' */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-category/footer-category.view.js'),
            cn: '@msdyn365-commerce-modules-footer-footer-category'
            };
viewDictionary['@msdyn365-commerce-modules|footer|modules|footer-item|footer-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-footer-footer-item' */
                '@msdyn365-commerce-modules/footer/dist/lib/modules/footer-item/footer-item.view.js'),
            cn: '@msdyn365-commerce-modules-footer-footer-item'
            };
viewDictionary['@msdyn365-commerce-modules|header|modules|header|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-header-header' */
                '@msdyn365-commerce-modules/header/dist/lib/modules/header/header.view.js'),
            cn: '@msdyn365-commerce-modules-header-header'
            };
viewDictionary['@msdyn365-commerce-modules|html-block|modules|html-block|html-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-html-block-html-block' */
                '@msdyn365-commerce-modules/html-block/dist/lib/modules/html-block/html-block.view.js'),
            cn: '@msdyn365-commerce-modules-html-block-html-block'
            };
viewDictionary['@msdyn365-commerce-modules|iframe|modules|iframe|iframe'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-iframe-iframe' */
                '@msdyn365-commerce-modules/iframe/dist/lib/modules/iframe/iframe.view.js'),
            cn: '@msdyn365-commerce-modules-iframe-iframe'
            };
viewDictionary['@msdyn365-commerce-modules|image-list|modules|image-list|image-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-image-list-image-list' */
                '@msdyn365-commerce-modules/image-list/dist/lib/modules/image-list/image-list.view.js'),
            cn: '@msdyn365-commerce-modules-image-list-image-list'
            };
viewDictionary['@msdyn365-commerce-modules|interactive-feature-collection|modules|interactive-feature-collection|interactive-feature-collection'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-collection' */
                '@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-collection/interactive-feature-collection.view.js'),
            cn: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-collection'
            };
viewDictionary['@msdyn365-commerce-modules|interactive-feature-collection|modules|interactive-feature-item|interactive-feature-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-item' */
                '@msdyn365-commerce-modules/interactive-feature-collection/dist/lib/modules/interactive-feature-item/interactive-feature-item.view.js'),
            cn: '@msdyn365-commerce-modules-interactive-feature-collection-interactive-feature-item'
            };
viewDictionary['@msdyn365-commerce-modules|invoice-details|modules|invoice-details|invoice-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-invoice-details-invoice-details' */
                '@msdyn365-commerce-modules/invoice-details/dist/lib/modules/invoice-details/invoice-details.view.js'),
            cn: '@msdyn365-commerce-modules-invoice-details-invoice-details'
            };
viewDictionary['@msdyn365-commerce-modules|invoice|modules|invoices-list|invoices-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-invoice-invoices-list' */
                '@msdyn365-commerce-modules/invoice/dist/lib/modules/invoices-list/invoices-list.view.js'),
            cn: '@msdyn365-commerce-modules-invoice-invoices-list'
            };
viewDictionary['@msdyn365-commerce-modules|map|modules|map|map'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-map-map' */
                '@msdyn365-commerce-modules/map/dist/lib/modules/map/map.view.js'),
            cn: '@msdyn365-commerce-modules-map-map'
            };
viewDictionary['@msdyn365-commerce-modules|media-gallery|modules|media-gallery|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-media-gallery-media-gallery' */
                '@msdyn365-commerce-modules/media-gallery/dist/lib/modules/media-gallery/media-gallery.view.js'),
            cn: '@msdyn365-commerce-modules-media-gallery-media-gallery'
            };
viewDictionary['@msdyn365-commerce-modules|navigation-menu|modules|navigation-menu|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-navigation-menu-navigation-menu' */
                '@msdyn365-commerce-modules/navigation-menu/dist/lib/modules/navigation-menu/navigation-menu.view.js'),
            cn: '@msdyn365-commerce-modules-navigation-menu-navigation-menu'
            };
viewDictionary['@msdyn365-commerce-modules|notifications-lists|modules|notifications-list|notifications-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-notifications-lists-notifications-list' */
                '@msdyn365-commerce-modules/notifications-lists/dist/lib/modules/notifications-list/notifications-list.view.js'),
            cn: '@msdyn365-commerce-modules-notifications-lists-notifications-list'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|checkout-order-confirmation|checkout-order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-checkout-order-confirmation' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/checkout-order-confirmation/checkout-order-confirmation.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-checkout-order-confirmation'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-confirmation|order-confirmation'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-confirmation' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-confirmation/order-confirmation.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-confirmation'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-details|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-details' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-details/order-details.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-details'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-history-with-search-and-filters|order-history-with-search-and-filters'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history-with-search-and-filters/order-history-with-search-and-filters.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history-with-search-and-filters'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-history|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-history' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-history/order-history.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-history'
            };
viewDictionary['@msdyn365-commerce-modules|order-management|modules|order-lookup|order-lookup'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-management-order-lookup' */
                '@msdyn365-commerce-modules/order-management/dist/lib/modules/order-lookup/order-lookup.view.js'),
            cn: '@msdyn365-commerce-modules-order-management-order-lookup'
            };
viewDictionary['@msdyn365-commerce-modules|order-template|modules|order-template-list|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-template-order-template-list' */
                '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template-list/order-template-list.view.js'),
            cn: '@msdyn365-commerce-modules-order-template-order-template-list'
            };
viewDictionary['@msdyn365-commerce-modules|order-template|modules|order-template|order-template'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-order-template-order-template' */
                '@msdyn365-commerce-modules/order-template/dist/lib/modules/order-template/order-template.view.js'),
            cn: '@msdyn365-commerce-modules-order-template-order-template'
            };
viewDictionary['@msdyn365-commerce-modules|product-collection|modules|product-collection|product-collection'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-collection-product-collection' */
                '@msdyn365-commerce-modules/product-collection/dist/lib/modules/product-collection/product-collection.view.js'),
            cn: '@msdyn365-commerce-modules-product-collection-product-collection'
            };
viewDictionary['@msdyn365-commerce-modules|product-comparison|modules|product-comparison-button|product-comparison-button'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-comparison-product-comparison-button' */
                '@msdyn365-commerce-modules/product-comparison/dist/lib/modules/product-comparison-button/product-comparison-button.view.js'),
            cn: '@msdyn365-commerce-modules-product-comparison-product-comparison-button'
            };
viewDictionary['@msdyn365-commerce-modules|product-comparison|modules|product-comparison-preview|product-comparison-preview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-comparison-product-comparison-preview' */
                '@msdyn365-commerce-modules/product-comparison/dist/lib/modules/product-comparison-preview/product-comparison-preview.view.js'),
            cn: '@msdyn365-commerce-modules-product-comparison-product-comparison-preview'
            };
viewDictionary['@msdyn365-commerce-modules|product-comparison|modules|product-comparison|product-comparison'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-comparison-product-comparison' */
                '@msdyn365-commerce-modules/product-comparison/dist/lib/modules/product-comparison/product-comparison.view.js'),
            cn: '@msdyn365-commerce-modules-product-comparison-product-comparison'
            };
viewDictionary['@msdyn365-commerce-modules|product-specification|modules|product-specification|product-specification'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-product-specification-product-specification' */
                '@msdyn365-commerce-modules/product-specification/dist/lib/modules/product-specification/product-specification.view.js'),
            cn: '@msdyn365-commerce-modules-product-specification-product-specification'
            };
viewDictionary['@msdyn365-commerce-modules|promo-banner|modules|promo-banner|promo-banner'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-promo-banner-promo-banner' */
                '@msdyn365-commerce-modules/promo-banner/dist/lib/modules/promo-banner/promo-banner.view.js'),
            cn: '@msdyn365-commerce-modules-promo-banner-promo-banner'
            };
viewDictionary['@msdyn365-commerce-modules|quick-order-grid|modules|quick-order-grid|quick-order-grid'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-quick-order-grid-quick-order-grid' */
                '@msdyn365-commerce-modules/quick-order-grid/dist/lib/modules/quick-order-grid/quick-order-grid.view.js'),
            cn: '@msdyn365-commerce-modules-quick-order-grid-quick-order-grid'
            };
viewDictionary['@msdyn365-commerce-modules|quick-order|modules|quick-order|quick-order'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-quick-order-quick-order' */
                '@msdyn365-commerce-modules/quick-order/dist/lib/modules/quick-order/quick-order.view.js'),
            cn: '@msdyn365-commerce-modules-quick-order-quick-order'
            };
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|ratings-histogram|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-ratings-histogram' */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/ratings-histogram/ratings-histogram.view.js'),
            cn: '@msdyn365-commerce-modules-ratings-reviews-ratings-histogram'
            };
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|reviews-list|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-reviews-list' */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/reviews-list/reviews-list.view.js'),
            cn: '@msdyn365-commerce-modules-ratings-reviews-reviews-list'
            };
viewDictionary['@msdyn365-commerce-modules|ratings-reviews|modules|write-review|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-ratings-reviews-write-review' */
                '@msdyn365-commerce-modules/ratings-reviews/dist/lib/modules/write-review/write-review.view.js'),
            cn: '@msdyn365-commerce-modules-ratings-reviews-write-review'
            };
viewDictionary['@msdyn365-commerce-modules|search-result-container|modules|search-result-container|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-search-result-container-search-result-container' */
                '@msdyn365-commerce-modules/search-result-container/dist/lib/modules/search-result-container/search-result-container.view.js'),
            cn: '@msdyn365-commerce-modules-search-result-container-search-result-container'
            };
viewDictionary['@msdyn365-commerce-modules|search|modules|search|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-search-search' */
                '@msdyn365-commerce-modules/search/dist/lib/modules/search/search.view.js'),
            cn: '@msdyn365-commerce-modules-search-search'
            };
viewDictionary['@msdyn365-commerce-modules|site-picker|modules|site-picker|site-picker'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-site-picker-site-picker' */
                '@msdyn365-commerce-modules/site-picker/dist/lib/modules/site-picker/site-picker.view.js'),
            cn: '@msdyn365-commerce-modules-site-picker-site-picker'
            };
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share-item|social-share-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-social-share-social-share-item' */
                '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share-item/social-share-item.view.js'),
            cn: '@msdyn365-commerce-modules-social-share-social-share-item'
            };
viewDictionary['@msdyn365-commerce-modules|social-share|modules|social-share|social-share'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-social-share-social-share' */
                '@msdyn365-commerce-modules/social-share/dist/lib/modules/social-share/social-share.view.js'),
            cn: '@msdyn365-commerce-modules-social-share-social-share'
            };
viewDictionary['@msdyn365-commerce-modules|spacer|modules|spacer|spacer'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-spacer-spacer' */
                '@msdyn365-commerce-modules/spacer/dist/lib/modules/spacer/spacer.view.js'),
            cn: '@msdyn365-commerce-modules-spacer-spacer'
            };
viewDictionary['@msdyn365-commerce-modules|store-selector|modules|store-selector|store-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-store-selector-store-selector' */
                '@msdyn365-commerce-modules/store-selector/dist/lib/modules/store-selector/store-selector.view.js'),
            cn: '@msdyn365-commerce-modules-store-selector-store-selector'
            };
viewDictionary['@msdyn365-commerce-modules|subscribe|modules|subscribe|subscribe'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-subscribe-subscribe' */
                '@msdyn365-commerce-modules/subscribe/dist/lib/modules/subscribe/subscribe.view.js'),
            cn: '@msdyn365-commerce-modules-subscribe-subscribe'
            };
viewDictionary['@msdyn365-commerce-modules|tab|modules|tab-item|tab-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tab-tab-item' */
                '@msdyn365-commerce-modules/tab/dist/lib/modules/tab-item/tab-item.view.js'),
            cn: '@msdyn365-commerce-modules-tab-tab-item'
            };
viewDictionary['@msdyn365-commerce-modules|tab|modules|tab|tab'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tab-tab' */
                '@msdyn365-commerce-modules/tab/dist/lib/modules/tab/tab.view.js'),
            cn: '@msdyn365-commerce-modules-tab-tab'
            };
viewDictionary['@msdyn365-commerce-modules|text-block|modules|text-block|text-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-text-block-text-block' */
                '@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block.view.js'),
            cn: '@msdyn365-commerce-modules-text-block-text-block'
            };
viewDictionary['@msdyn365-commerce-modules|tile-list|modules|tile-list-item|tile-list-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tile-list-tile-list-item' */
                '@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list-item/tile-list-item.view.js'),
            cn: '@msdyn365-commerce-modules-tile-list-tile-list-item'
            };
viewDictionary['@msdyn365-commerce-modules|tile-list|modules|tile-list|tile-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-tile-list-tile-list' */
                '@msdyn365-commerce-modules/tile-list/dist/lib/modules/tile-list/tile-list.view.js'),
            cn: '@msdyn365-commerce-modules-tile-list-tile-list'
            };
viewDictionary['@msdyn365-commerce-modules|video-player|modules|video-player|video-player'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-video-player-video-player' */
                '@msdyn365-commerce-modules/video-player/dist/lib/modules/video-player/video-player.view.js'),
            cn: '@msdyn365-commerce-modules-video-player-video-player'
            };
viewDictionary['@msdyn365-commerce-modules|wishlist|modules|wishlist-items|wishlist-items'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-modules-wishlist-wishlist-items' */
                '@msdyn365-commerce-modules/wishlist/dist/lib/modules/wishlist-items/wishlist-items.view.js'),
            cn: '@msdyn365-commerce-modules-wishlist-wishlist-items'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|b2b-requests-status'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-b2b-requests-status' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/b2b-requests-status.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-b2b-requests-status'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|business-organization-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-business-organization-list' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/business-organization-list.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-business-organization-list'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|buybox'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-buybox' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/buybox.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-buybox'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|cart-icon'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart-icon' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/cart-icon.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart-icon'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|cart'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/cart.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-cart'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|checkout-customer-account-payment'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-checkout-customer-account-payment' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/checkout-customer-account-payment.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-checkout-customer-account-payment'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|content-block'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-content-block' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/content-block.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-content-block'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|footer-item'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-footer-item' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/footer-item.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-footer-item'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|header'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-header' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/header.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-header'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|media-gallery'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-media-gallery' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/media-gallery.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-media-gallery'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|navigation-menu'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-navigation-menu' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/navigation-menu.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-navigation-menu'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|order-details'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-details' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/order-details.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-details'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|order-history'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-history' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/order-history.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-history'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|order-template-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-template-list' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/order-template-list.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-order-template-list'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|quickview'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-quickview' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/quickview.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-quickview'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|ratings-histogram'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-ratings-histogram' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/ratings-histogram.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-ratings-histogram'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|reviews-list'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-reviews-list' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/reviews-list.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-reviews-list'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|search-result-container-v2'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container-v2' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/search-result-container-v2.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container-v2'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|search-result-container'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/search-result-container.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-search-result-container'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|search'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-search' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/search.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-search'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|sign-in'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-sign-in' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/sign-in.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-sign-in'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|store-selector'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-store-selector' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/store-selector.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-store-selector'
            };
viewDictionary['@msdyn365-commerce-theme|adventureworks-theme-kit|modules|adventureworks|views|write-review'] = {
            c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '@msdyn365-commerce-theme-adventureworks-theme-kit-write-review' */
                '@msdyn365-commerce-theme/adventureworks-theme-kit/dist/lib/modules/adventureworks/views/write-review.view.js'),
            cn: '@msdyn365-commerce-theme-adventureworks-theme-kit-write-review'
            };